export default __webpack_public_path__ + "static/media/info.88d2699e.svg";